
import { Component, Vue, Prop } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { getOrderCurveCharging } from "@/api/api-charge-service";
import echartLine from "@/views/operation-analysis/site-monitor/components/children/echart-line.vue";
import { echartsJS } from "@/common/add-js";
import i18n from "@/config/i18n";
@Component({
  components: {
    echartLine
  }
})
export default class PiBillingDataEchartLine extends Vue {
  @Prop({ default: "" }) orderNo!: string;
  @Prop({
    default: () => {
      return {};
    }
  })
  private infoData!: objAny;

  private loaded = false;

  /**
   * 默认个度 60
   */
  private second = 60;
  private chargeElectricList: objAny[] = [];

  async getOrderCurveCharging(): Promise<void> {
    if (!this.orderNo) {
      return;
    }
    const ret = await getOrderCurveCharging({ orderNo: this.orderNo });
    if (ret.status == this["$config"].apiStatus) {
      const data = ret.data[0];
      let chargeEndTime = this.infoData.chargeEndTime;
      if (
        !chargeEndTime &&
        data.chargeElectricList &&
        data.chargeElectricList.length > 0
      ) {
        chargeEndTime =
          data.chargeElectricList[data.chargeElectricList.length - 1].recTime;
      }
      this.diffTime(this.infoData.chargeBeginTime, chargeEndTime);

      const chargeElectricList = data.chargeElectricList || [];
      const serviceAmountList = data.serviceAmountList || [];
      const transactionAmountList = data.transactionAmountList || [];
      this.loaded = true;
      this.chargeElectricList = [
        this.getConvertEchartData(
          chargeElectricList,
          i18n.t("commonTableName.chargeElect") + "",
          "#FF0000"
        ),
        this.getConvertEchartData(
          serviceAmountList,
          i18n.t("commonTableName.serviceAmount") + "",
          "#AD95FF"
        ),
        this.getConvertEchartData(
          transactionAmountList,
          i18n.t("commonTableName.totalAmount") + "",
          "#14C058"
        )
      ];
    }
  }

  public getConvertEchartData(
    list: objAny[],
    name: string,
    color: string
  ): objAny {
    const timeList: objAny[] = [];
    list.map((item: objAny, index: number) => {
      if (index == 0 && item.recTime != this.infoData.chargeBeginTime) {
        timeList.push([this.infoData.chargeBeginTime, ""]);
      }
      timeList.push([item.recTime, item.value]);
      if (
        index == list.length - 1 &&
        item.recTime != this.infoData.chargeEndTime
      ) {
        timeList.push([this.infoData.chargeEndTime, ""]);
      }
    });
    const cItem = {
      name: name,
      color: color,
      data: timeList
    };
    return cItem;
  }

  /**
   * 相差时间
   * @param startTime
   * @param endTime
   */
  diffTime(startTime: string, endTime: string): void {
    if (!startTime || !endTime) {
      return;
    }
    const start = Number(new Date(startTime));
    const end = Number(new Date(endTime));
    const diff = (end - start) / 1000; // 得出相差几秒
    const maxIn = 20;

    if (diff / this.second > maxIn) {
      this.second = parseInt(diff / maxIn + "");
    }
  }
  async created(): Promise<void> {
    await echartsJS();
    this.getOrderCurveCharging();
  }
}
